import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Home from '@/components/Home'
import NoLogin from '@/components/NoLogin'
import PageNotFound from '@/components/Error/PageNotFound'

Vue.use(Router)
Vue.use(VueAxios, axios)

const domain = (new URL(process.env.API_URL))
const debug = (domain && (domain.hostname.endsWith('.longdo.com') || domain.hostname === 'localhost'))
if (debug) {
  console.log('debug true')
}

const routerConfig = {
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/app-dga',
      name: 'NoLogin',
      component: NoLogin
    },
    {
      path: '/app-redirect/:platform',
      name: 'AppRedirect',
      component: () => import(/* webpackChunkName: "AppRedirect" */ '@/components/AppRedirect')
    },
    // {
    //   path: '/mappoi',
    //   name: 'MapPoiList',
    //   component: () => import(/* webpackChunkName: "MapPoiList" */ '@/components/MapPoiList'),
    //   props: true
    // },
    {
      path: '/maptrip/:stationId',
      name: 'MapTripList',
      component: () => import(/* webpackChunkName: "MapTripList" */ '@/components/MapTripList'),
      props: true
    },
    {
      path: '/bma/stop/:stationId',
      name: 'MapTripListAlt',
      component: () => import(/* webpackChunkName: "MapTripListAlt" */ '@/components/MapTripListAlt')
    },
    {
      path: '/bma/stop-v2/:stationId',
      name: 'MapTripListAlt',
      component: () => import(/* webpackChunkName: "MapTripListAltV2" */ '@/components/MapTripListAltV2')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "Login" */ '@/components/Login'),
    },
    {
      path: '/place',
      name: 'Place',
      component: () => import(/* webpackChunkName: "Place" */ '@/components/Place'),
      props: true
    },
    {
      path: '/searchroute',
      name: 'SearchRoute',
      component: () => import(/* webpackChunkName: "SearchRoute" */ '@/components/SearchRoute'),
      props: true
    },
    {
      path: '/s/:params',
      name: 'SharedRoute',
      component: () => import(/* webpackChunkName: "SearchRoute" */ '@/components/SearchRoute'),
      props: true
    },
    {
      path: '/bus',
      name: 'Bus',
      component: () => import(/* webpackChunkName: "Bus" */ '@/components/Bus'),
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import(/* webpackChunkName: "Search" */ '@/components/Search'),
    },
    {
      path: '/bustrip/:tripId',
      name: 'BusTrip',
      component: () => import(/* webpackChunkName: "BusTrip" */ '@/components/BusTrip'),
      props: true
    },
    {
      path: '/favorite',
      name: 'Favorites',
      component: () => import(/* webpackChunkName: "Favorites" */ '@/components/Favorites'),
    },
    {
      path: '/landmark',
      name: 'Landmarks',
      component: () => import(/* webpackChunkName: "Landmarks" */ '@/components/Landmarks'),
    },
    {
      path: '/traffic',
      name: 'traffic',
      component: () => import(/* webpackChunkName: "Traffic" */ '@/components/Traffic'),
    },
    {
      path: '/landmarkpoi',
      name: 'LandmarkPoiList',
      component: () => import(/* webpackChunkName: "LandmarkPoiList" */ '@/components/LandmarkPoiList'),
      props: true
    },
    {
      path: '/event',
      name: 'Events',
      component: () => import(/* webpackChunkName: "Events" */ '@/components/Events'),
    },
    {
      path: '/event/:eventId',
      name: 'EventDetail',
      component: () => import(/* webpackChunkName: "EventDetail" */ '@/components/EventDetail'),
    },
    {
      path: '/announce',
      name: 'Announce',
      component: () => import(/* webpackChunkName: "Announce" */ '@/components/Announce'),
    },
    {
      path: '/news',
      name: 'News',
      component: () => import(/* webpackChunkName: "News" */ '@/components/News'),
    },
    {
      path: '/route',
      name: 'Route',
      component: () => import(/* webpackChunkName: "Route" */ '@/components/Route'),
      props: true
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "About" */ '@/components/About'),
    },
    {
      path: '/support',
      name: 'Support',
      component: () => import(/* webpackChunkName: "Support" */ '@/components/Support'),
    },
    {
      path: '/opendata',
      name: 'Opendata',
      component: () => import(/* webpackChunkName: "Opendata" */ '@/components/Opendata'),
    },
    {
      path: '/setting',
      name: 'Settings',
      component: () => import(/* webpackChunkName: "Settings" */ '@/components/Settings'),
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import(/* webpackChunkName: "Privacy" */ '@/components/Privacy'),
    },
    {
      path: '/linelogin',
      name: 'LineLogin',
      component: () => import(/* webpackChunkName: "LineLogin" */ '@/components/LineLogin'),
    },
    {
      path: '/fblogin',
      name: 'FacebookLogin',
      component: () => import(/* webpackChunkName: "FacebookLogin" */ '@/components/FacebookLogin'),
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import(/* webpackChunkName: "Logout" */ '@/components/Logout'),
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
}

if (debug) {
  routerConfig.routes.push({
    path: '/bustripdebug/:tripId',
    name: 'BusTripDebug',
    component: () => import(/* webpackChunkName: "BusTrip" */ '@/components/BusTrip'),
    props: true
  })
  routerConfig.routes.push({
    path: '/maptripdebug/:stationId',
    name: 'MapTripListDebug',
    component: () => import(/* webpackChunkName: "MapTripList" */ '@/components/MapTripList'),
    props: true
  })
}

export default new Router(routerConfig)
